const FocusSection = () => {
  return (
    <section className="bg-white py-56">
      <div className="w-4/5 mx-auto">
        <div className="max-w-4xl mx-auto">
          <div className="w-24 h-px bg-[#2B2D33] mx-auto mb-8"></div>
          <h2
            className="text-5xl font-light text-[#2B2D33] leading-tight mb-16 text-center"
            style={{ fontFamily: 'Crimson Text, serif' }}
          >
            Small Gaps. Compounding Impact.
          </h2>

          <div className="space-y-8 max-w-3xl mx-auto">
            <p className="text-lg text-[#6B6D72] leading-relaxed">
              Many operators believe they understand their margins.
            </p>

            <p className="text-lg text-[#6B6D72] leading-relaxed">
              <strong className="text-[#2B2D33]">Visibility gaps</strong> create delayed awareness. EBITDA erosion is often subtle and cumulative.
            </p>

            <p className="text-lg text-[#6B6D72] leading-relaxed">
              This is rarely a dramatic failure — it is <strong className="text-[#2B2D33]">compounding</strong>.
            </p>

            <div className="pt-8 space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-[#2B2D33] rounded-full mt-2.5 flex-shrink-0"></div>
                <p className="text-lg text-[#6B6D72] leading-relaxed">
                  Service cost capture drifts without structured review
                </p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-[#2B2D33] rounded-full mt-2.5 flex-shrink-0"></div>
                <p className="text-lg text-[#6B6D72] leading-relaxed">
                  Project variance patterns remain unexamined
                </p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-[#2B2D33] rounded-full mt-2.5 flex-shrink-0"></div>
                <p className="text-lg text-[#6B6D72] leading-relaxed">
                  Pricing discipline weakens incrementally
                </p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-[#2B2D33] rounded-full mt-2.5 flex-shrink-0"></div>
                <p className="text-lg text-[#6B6D72] leading-relaxed">
                  Working capital visibility becomes opaque
                </p>
              </div>
            </div>

            <p className="text-lg text-[#6B6D72] leading-relaxed pt-8">
              The result: <strong className="text-[#2B2D33]">invisible compounding</strong> that erodes enterprise value over time.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FocusSection;
